import React from 'react';
import { Trans } from '@lingui/macro';
import {
  TAddType,
} from '@goldwasserexchange/oblis-frontend-utils';
import { useHookstate } from '@hookstate/core';
import { useUser } from '../utils';

const TAddCountryLabelMoralPart = (props: React.PropsWithChildren<{}>) => {
  const {
    children,
  } = props;
  const userState = useUser();
  const tAddTypeState = useHookstate(userState.T_ADD_type);
  if (tAddTypeState.get() !== TAddType.MORAL) {
    return null;
  }
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

export const tAddCountryLabel = (
  <Trans>
    Pays
    <TAddCountryLabelMoralPart>&#32;du siège social</TAddCountryLabelMoralPart>
  </Trans>
);
